import { Group } from '../group';
import { User } from '../user';
import { EventStatus, TimeOfDay } from './types';

export interface Event {
  id: string;
  group: Group;
  status: EventStatus;
  category: string;
  price?: number;
  createdBy: User;
  currency?: string;
  date?: Date;
  title: string;
  startTime?: Date;
  endTime?: Date;
  booked?: boolean;
  location: {
    name: string;
    address: string;
    coordinates: number[];
  };
  banner?: string;
  description?: string;
  preferredTimesOfTheDay: TimeOfDay[];
  minUsers?: number;
  maxUsers?: number;
  createdAt: string;
  updatedAt: string;

  // Extended properties
  joined?: boolean;
  extended?: boolean;
  canJoin?: boolean;
  isCreator?: boolean;
  pending?: boolean;
}

export function createGameEvent(params: Partial<Event>) {
  return {} as Event;
}
